import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Pagination,
    Typography,
    Box
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Scrollbar from '../../../Scrollbar';
import CafeteriaTableHead from './cafeteriaTableHeader';
import CafeteriaTableRow from './cafeteriaTableRow';
import { getCafeteriaMasterWatcher } from '../../../../redux/actionCreators/admin/cafeteria';

const TABLE_HEAD = [
    { id: 'idNumber', label: 'ID Number', alignRight: false },
    { id: 'cafeteria', label: 'Cafeteria Name', alignRight: false },
];

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
}

const CafeteriaTable = () => {

    let firstIndex = 0;

    const dispatch = useDispatch();
    const { CafeteriaReducers: { cafeteriaMasterList } } = useSelector((state) => state)

    const [page, setPage] = useState(1);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [rowsPerPage] = useState(5);

    useEffect(() => {
        dispatch(getCafeteriaMasterWatcher())
    }, [dispatch])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const filteredData = applySortFilter(cafeteriaMasterList, getComparator(order, orderBy));
    const isNotFound = filteredData?.length === 0;

    return (
        <>
            <Box>
                <Scrollbar>
                    <TableContainer sx={{ minWidth: 600, overflow: 'unset' }}>
                        <Table>
                            <CafeteriaTableHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD}
                                onRequestSort={handleRequestSort}
                            />
                            <TableBody>
                                {filteredData?.slice(firstIndex + rowsPerPage * (page - 1), rowsPerPage * page)
                                    .map((m) => (
                                        <CafeteriaTableRow key={m.nID} rowData={m} />
                                    ))}
                            </TableBody>
                            {isNotFound && (
                                <TableBody>
                                    <TableRow display='flex'>
                                        <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                                            <Typography variant='t18_500' >
                                                No records found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Box>
            <Box spacing={2} display='flex' justifyContent='right' paddingTop='20px' >
                <Pagination
                    shape="rounded"
                    color='primary'
                    count={Math.ceil(cafeteriaMasterList?.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                />
            </Box>
        </>
    )
}

export default CafeteriaTable;
